namespace TabAurous.Master {
    export interface CamlyticsForm {
        Url: Serenity.StringEditor;
        CompanyId: Serenity.LookupEditor;
        ChannelId: Serenity.StringEditor;
    }

    export class CamlyticsForm extends Serenity.PrefixedContext {
        static formKey = 'Master.Camlytics';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CamlyticsForm.init)  {
                CamlyticsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(CamlyticsForm, [
                    'Url', w0,
                    'CompanyId', w1,
                    'ChannelId', w0
                ]);
            }
        }
    }
}
